import type { ProfileResource } from '@medplum/core'
import { cn } from '@seen/ui'
import type { JSX } from 'react'
import { Avatar } from '#src/components/core/Avatar/Avatar.tsx'
import { EditButton } from '#src/components/patient/detail-content/contact-tab/EditButton.tsx'
import { useIsReadOnly } from '#src/hooks/useIsReadOnly.ts'

export function EditableAvatar({
  profile,
  className,
}: {
  profile: ProfileResource | undefined
  className?: string
}): JSX.Element {
  const isReadOnly = useIsReadOnly()
  return (
    <Avatar profile={profile} className={cn('relative', className)}>
      {!isReadOnly && profile && (
        <EditButton
          profile={profile}
          field="photo"
          className="absolute bg-muted opacity-0 hover:opacity-100"
        />
      )}
    </Avatar>
  )
}
